const customArtworkLayer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_CUSTOM_LAYER':
            return {
                leftArtwork: {
                    id: 'leftArtwork'
                },
                rightArtwork: {
                    id: 'rightArtwork'
                }
            };
        case 'UPDATE_CUSTOM_LAYER':
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    ...action.payload
                }
            };
        case 'SET_FLIP_CONTROL_BUTTON':
            return {
                ...state,
                isFlipped: action.payload
            };
        case 'SET_MIRROR_CONTROL_BUTTON':
            return {
                ...state,
                isMirrored: action.payload
            };
        /*
          TODO:
          Needs to track which layer changed and use the difference from the layer that was changed
         */
        case 'UPDATE_BOTH_CUSTOM_LAYERS': {
            const side = action.payload;
            const oldState = state[side.id];
            const stateList = Object.keys(state).filter(
                (key) => state[key].id !== side.id && key.includes('Artwork') === true
            );
            // console.log(side);
            let oppositeLayer = { ...state[stateList[0]] };
            if (oldState) {
                let xDiff = side.x - (oldState.x ? oldState.x : 0);
                let yDiff = side.y - (oldState.y ? oldState.y : 0);
                // console.log(xDiff, yDiff);
                oppositeLayer.x = oppositeLayer.x ? oppositeLayer.x - xDiff : -xDiff;
                oppositeLayer.y = oppositeLayer.y ? oppositeLayer.y + yDiff : yDiff;
                oppositeLayer.scaleY = side.scaleY;
                oppositeLayer.scaleX = side.scaleX;
                oppositeLayer.rotation = -side.rotation;
                oppositeLayer.skewX = side.skewX;
                oppositeLayer.skewY = side.skewY;
            }
            return {
                ...state,
                [side.id]: {
                    ...side
                },
                [oppositeLayer.id]: {
                    ...oppositeLayer
                }
                // leftArtwork: {
                //     ...state['leftArtwork']
                // },
                // rightArtwork: {
                //     ...state['rightArtwork']
                // }
            };
        }
        case 'RESET_LEFT_CUSTOM_LAYER':
            return {
                ...state,
                leftArtwork: action.payload
            };
        case 'RESET_RIGHT_CUSTOM_LAYER':
            return {
                ...state,
                rightArtwork: action.payload
            };
        case 'RESET_CUSTOM_LAYER':
            return {
                leftArtwork: action.payload['leftArtwork'],
                rightArtwork: action.payload['rightArtwork'],
                isMirrored: false,
                isFlipped: false
            };
        case 'FLIP_CUSTOM_LAYERS':
            return {
                ...state,
                leftArtwork: action.payload['leftArtwork']
                    ? { ...action.payload['leftArtwork'] }
                    : state.leftArtwork,
                rightArtwork: action.payload['rightArtwork']
                    ? { ...action.payload['rightArtwork'] }
                    : state.rightArtwork
            };
        case 'CENTER_CUSTOM_LAYERS':
            return {
                ...state,
                leftArtwork: action.payload['leftArtwork']
                    ? { ...action.payload['leftArtwork'] }
                    : state.leftArtwork,
                rightArtwork: action.payload['rightArtwork']
                    ? { ...action.payload['rightArtwork'] }
                    : state.rightArtwork
            };
        default:
            return state;
    }
};

export default customArtworkLayer;
